import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Autocomplete, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import "firebase/firestore";
import _ from "lodash";
import * as React from "react";
import { useEffect, useState } from "react";
import { nbfMonthlyDailyReport } from "../../api/restApi";
import AutoComplete from "../../components/AutoComplete";
import RadioButton from "../../components/RadioButton";
import InvoiceModal from "../../components/modals/InvoiceModal";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { customerDataForAutoComplete } from "../../store/reducer/customersSlice";
import { ordersData } from "../../store/reducer/ordersSlice";
import {
  addPrefix,
  generateMonthlyBillForCustomer,
  monthNames,
} from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import { useSelector } from "react-redux";

export default function DashboardReports() {
  console.log(monthNames);
  const name = useSelector((state) => state.currentUser.name);
  const role = useSelector((state) => state.currentUser.role);
  const months = [

    monthNames
      .map((month, index) => {
        // if (index <= moment().months()) {
          const data = {
            id: addPrefix(index + 1),
            label: month,
          };
          return data;
        // }
        // return null;
      })
      .filter((month) => month !== null), 
  ];
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const [openLoader, setOpenLoader] = useState(false);

  const customersDataAll = useAppSelector(customerDataForAutoComplete);
  let filteredCustomersData = customersDataAll;
  if (role === "cs") {
    filteredCustomersData = filteredCustomersData.filter(customer => customer.id == name);
  }
  const customersData=filteredCustomersData
  
  const options = role === "cs" ? customersData : customersDataAll;

  const { ordersDate } = useAppSelector(ordersData);
  
  const [customerID, setCustomerID] = useState(undefined);
  const [month, setMonth] = useState(months[0].id);
  const [selectedDay, setSelectedDay] = useState(undefined);
  const [date1, setDate1] = useState(undefined);
  const [date2, setDate2] = useState(undefined);
  const [showPdf, setShowPdf] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [option1, setOption1] = useState("Select Customer");
  const [option2, setOption2] = useState("Month");
  const [openInvoice, setOpenInvoice] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedType, setSelectedType] = useState("All");
  const [category, setCategory] = useState([]);
  const [type, setType] = useState([]);
  const [totalSum,setTotalSum]=useState('');
  useEffect(() => {
    setCustomerID(undefined);
    setMonth(undefined);
    setSelectedDay(undefined);
  }, [option1, option2]);

  useEffect(() => {
    showMonthlyReport(false);
    if(selectedCategory==="All"){
      setType("")
    }
  }, [selectedCategory,selectedType, selectedDay, month]);


  const handleSelectCustomer = async (event, newValue) => {
    setCustomerID(newValue !== null ? newValue.id : undefined);
    setSelectedCategory("All");
    setSelectedType("All");
    setSelectedDay('');
  };

  const handleSelectMonth = async (event, newValue) => {
    setMonth(newValue !== null ? newValue.id : undefined);
    setSelectedCategory("All");
    setSelectedType("All");
  };

  const handleSelectDate = (event, newDate) => {
    setSelectedDay(newDate);
    setSelectedCategory("All");
    setSelectedType("All");
  };

  const handleSelectCagegory = async (event, newValue) => {
    setSelectedCategory(newValue);
    setSelectedType("All");
  };

  const handleSelectType = async (event, newValue) => {
    setSelectedType(newValue);
  };


  const showMonthlyReport = async (flag) => {
    if (
      (option1 !== "All" && customerID === undefined) ||
      (option1 !== "All" && month === undefined && selectedDay === undefined)
    ) {
      return;
    } else if (month === undefined && selectedDay === undefined) {
      return;
    }

    setOpenLoader(true);
    let response = await nbfMonthlyDailyReport(
      customerID,
      selectedDay,
      month,
      date1,
      date2
    );
    setInvoice({});
    setOpenLoader(false);
    let customer = customersData.find((customer) => customer.id === customerID);
    const orderDetail = await generateMonthlyBillForCustomer(
      {
        ...response,
        ...customer,
      },
      monthNames[Number(month) - 1]
    );

    let orderCategory = [];
    const groups = _.groupBy(orderDetail.items, "category_english");
    Object.entries(groups).map(([key, value]) => {
      orderCategory.push(key);
    });

    setCategory([...orderCategory]);

    const filteredCatProducts = orderDetail.items?.filter(
      (el) => el.category_english === selectedCategory
    );

    if (selectedCategory === "All" && selectedType === "All") {
      setInvoice(orderDetail);
    } else {
      let orderType = [];
      const TypeGroups = _.groupBy(filteredCatProducts, "type_english");
      Object.entries(TypeGroups).map(([key, value]) => {
        orderType.push(key);
      });

      setType([...orderType]);

      const order = orderDetail.items?.filter(
        (el) => el.type_english === selectedType
      );

      function calculateTotalSum(productArray) {
        let totalSum = 0;
        for (const product of productArray) {
          totalSum += product.quantity * product.price;
        }
        setTotalSum(totalSum)
      }

      calculateTotalSum(order);

      console.log(orderDetail, order);
      const newOrder = {
        ArrearData: orderDetail.ArrearData,
        ArrearPayment: orderDetail.ArrearPayment,
        address_english: orderDetail.address_english,
        address_urdu: orderDetail.address_urdu,
        advancePayment: orderDetail.advancePayment,
        balance: orderDetail.balance,
        bill: totalSum,
        city_english: orderDetail.city_english,
        city_urdu: orderDetail.city_urdu,
        date: orderDetail.date,
        delivery_charges: orderDetail.delivery_charges,
        due_date: orderDetail.due_date,
        id: orderDetail.id,
        invoice_no: orderDetail.invoice_no,
        name_english: orderDetail.name_english,
        name_urdu: orderDetail.name_urdu,
        pay: orderDetail.pay,
        payment: orderDetail.payment,
        preparedBy: orderDetail.preparedBy,
        returnAmount: orderDetail.returnAmount,
        username: orderDetail.username,
      };

      setInvoice({
        ...newOrder,
        items: order,
      });

      console.log(invoice);

      if (selectedType === "All") {
        calculateTotalSum(filteredCatProducts);
        setInvoice({ ...newOrder, items: filteredCatProducts });
      } else {
        calculateTotalSum(filteredCatProducts.filter(
          (el) => el.type_english === selectedType
        ))
        setInvoice({
          ...newOrder,
          items: filteredCatProducts.filter(
            (el) => el.type_english === selectedType
          ),
        });
      }
    }

    if (flag) {
      setShowPdf(true);
      setOpenInvoice(true);
    }
  };

  const handleOption1 = (event) => {
    setOption1(event.target.value);
  };
  const handleOption2 = (event) => {
        setOption2(event.target.value);
  };

  const handleInvoiceModal = () => {
    setOpenInvoice(!true);
  };

  return (
    <div>
      <Stack alignItems="center" spacing={1} marginTop="0rem">
        <Box sx={{ flexGrow: 0 }}>
          <Grid item xs={24} md={6}>
            <Card
              alignItems="start"
              sx={{
                width: "100%",
                marginTop: "0rem",
                "@media (min-width: 300px)": {
                  width: 350, // Set the width to 100% for mobile view
                },
                "@media (min-width: 650px)": {
                  width: 650, // Set the width to 650px for screens wider than 650px
                },
              }}
            >
              <CardContent>
                <Stack
                  flex="1"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                  direction="column"
                  marginBottom="1rem"
                >
                  <label
                    style={{ minWidth: isMediumScreen ? "400px" : "300px" }}
                  >
                    <Button
                      style={{
                        width: "100%",
                      }}
                      variant="contained"
                      color="success"
                      onClick={() => showMonthlyReport(true)}
                    >
                      View Report
                    </Button>
                  </label>
                  <label
                    style={{ minWidth: isMediumScreen ? "400px" : "300px" }}
                  >
  <Stack>
  {role !== "cs" && (
  <RadioButton
    style={{
      width: "100%",
      alignItems: "center",
    }}
    val={option1}
    handleChange={handleOption1}
    option1="Select Customer"
    option2="All"
  />
)}
  {option1 !== "All" && (
<AutoComplete
  style={{
    width: "100%",
  }}
  options={options ? options : []}
  value={customerID}
  onChange={handleSelectCustomer}
  label="Select a Customer"
/>
)}
  </Stack>
                  </label>
                  {/* <label
                    style={{ minWidth: isMediumScreen ? "400px" : "300px" }}
                  > */}
                  <Stack>
                    <RadioButton
                      style={{
                        width: "100%",
                      }}
                      val={option2}
                      handleChange={handleOption2}
                      option1="Month"
                      option2="Date"
                    />


                    {option2 === "Month" ? (
                      <AutoComplete
                        style={{
                          width: "100%",
                        }}
                        options={months[0]}
                        id={month}
                        onChange={handleSelectMonth}
                        label="Select a Month"
                      />
                    ) : (
                      <Autocomplete
                        style={{
                          width: "100%",
                        }}
                        disablePortal
                        id="combo-box-demo"
                        options={ordersDate}
                        onChange={handleSelectDate}
                        value={selectedDay}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select a Date" />
                        )}
                      />
                    )}
                    </Stack>
                  {/* </label> */}

                  <Stack direction="row" spacing={2} justifyContent="center">
                    <Autocomplete
                      style={{
                        minWidth: "73%",
                      }}
                      disablePortal
                      id="combo-box-demo2"
                      options={["All", ...category]}
                      // sx={{
                      //   minWidth: isMediumScreen ? "200px" : "100px",
                      //   display: "flex",
                      //   justifyContent: "center",
                      //   padding: 1,
                      // }}
                      value={selectedCategory}
                      onChange={handleSelectCagegory}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Category" />
                      )}
                    />

                    <Autocomplete
                      style={{
                        minWidth: "73%",
                      }}
                      disablePortal
                      id="combo-box-demo3"
                      options={["All", ...type]}
                      // sx={{
                      //   minWidth: isMediumScreen ? "200px" : "100px",
                      //   display: "flex",
                      //   justifyContent: "center",
                      //   padding: 1,
                      // }}
                      value={selectedType}
                      onChange={handleSelectType}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Type" />
                      )}
                    />
                  </Stack>


                  {showPdf && (
                    <InvoiceModal
                      openInvoice={openInvoice}
                      orderByCustomer={invoice}
                      setOpenInvoice={handleInvoiceModal}
                    />
                  )}
                  <OverlayLoader open={openLoader} />
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Stack>
    </div>
  );
}
